import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ShopContractTypeNewEditForm from './ShopContractTypeNewEditForm';
// ----------------------------------------------------------------------

export default function ShopContractTypeCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('ShopContractType.AddTitle')}`
          : `${translate('ShopContractType.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('ShopContractType.CreateShopContractType')}`
              : `${translate('ShopContractType.EditShopContractType')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ShopContractType.ShopContractTypeList')}`,
              href: PATH_DASHBOARD.ShopContractType.list,
            },
            {
              name: !isEdit
                ? `${translate('ShopContractType.New')}`
                : `${translate('ShopContractType.Update')}`,
            },
          ]}
        />
        <ShopContractTypeNewEditForm />
      </Container>
    </Page>
  );
}
